import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { CancelBtn } from "../components/cancelBtn";
import { useParams, useNavigate } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import axios from "axios";
import { TransactionSaveBtn } from "../components/transactionSaveBtn";

function AddTransaction() {

  const API_URL = process.env.REACT_APP_API_URL;

  const { id } = useParams();
  //For balance
  const [currentBalance, setCurrentBalance] = useState({});
  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({ mode: "onSubmit" });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [cancelClicked, setCancelClicked] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [sigSaved, setSigSaved] = useState(false);
  const [promotion, setPromotion] = useState("None");
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${API_URL}/clients/${id}`)
      .then((response) => {
        setCurrentBalance(response.data.balance);
      })
      .catch((err) => {
        setError(err.message);
      });
  }, [currentBalance, id, API_URL]);

  // For Signature
  const sigCanvasRef = useRef({});
  const [trimmedDataURL, setTrimmedDataURL] = useState(null);
  const clear = () => {
    sigCanvasRef.current.clear();
    setTrimmedDataURL(null);
    setSigSaved(false);
  };
  const save = () => {
    if (sigCanvasRef.current.isEmpty() && !cancelClicked) {
      alert("Please provide a signature first.");
      return;
    }
    setSigSaved(true);
    const dataURL = sigCanvasRef.current.getCanvas().toDataURL("image/png");
    alert("Signature saved");
    setTrimmedDataURL(dataURL);
  };

  const onSubmit = async (data, event) => {
    const action = event.nativeEvent.submitter.value;

    setError(null);
    const newTransaction = {
      ...data,
      promotion: promotion,
      clientId: id,
      datecreated: startDate,
      signature: trimmedDataURL,
    };
    try {
      if (action !== "submit") {
        return;
      }
      if(sigSaved){
        if (action === "submit") {
          const response = await axios.post(
            `${API_URL}/transactions/`,
            newTransaction
          );
          const formData = {
            promotion : newTransaction.promotion,
            amount: newTransaction.amount,
            tip: newTransaction.tip
          };
          const result = await axios.put(
            `${API_URL}/transactions/clients/${id}/subtract`,
            formData
          );
          if (response.data != null && result.data != null && !cancelClicked) {
            alert("Created new transaction");
            navigate(`/clients/${id}`);
          } else {
            alert("Something went wrong while creating a new transaction. Please try ig again later");
          }
        }
      } else{
        alert("Please save the signature please");
      }
    } catch {
      setError(
        "Something went wrong while creating new transaction. Please try again later"
      );
      alert(error);
    } finally {
      if (action === "submit") {
        setIsLoading(true);
      }
    }
  };
  const onCancel = () => {
    setCancelClicked(true);
    navigate(`/clients/${id}`);
  };
  const getDateValue = (data) => {
    setStartDate(data);
  };
 
  return (
    <div className="h-dvh flex items-center flex-col bg-[#545454]">
      <title>Add Transaction | HairBank</title>
      <div className="flex w-4/5 items-end text-center">
        <div className="w-full">
          <h1 className="text-[#eed495] text-6xl mt-16 xl:mt-5 w-full">
            Add Transaction
          </h1>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex border-2 mt-20 flex-col h-auto justify-center">
          <div className="flex items-center justify-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="serviceName">Service Name:</label>
            </div>
            <div>
              <input
                {...register("serviceName", {
                  required: "Service name is required",
                })}
                name="serviceName"
                required
                type="text"
                placeholder="serviceName"
                className="w-72 text-2xl text-white bg-[#7a7a7a] focus:outline-none m-3 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          {errors.serviceName?.message && (
            <div className="text-2xl text-red-400 text-center">
              <span>{errors.serviceName?.message}</span>
            </div>
          )}
          <div className="flex items-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="promotion">Promotion:</label>
            </div>
            <div>
            <select id="promotions" onChange={(e)=>setPromotion(e.target.value)} className="text-2xl w-32 ml-3">
                <option value="None">None</option>
                <option value="10%">10%</option>
                <option value="15%">15%</option>
                <option value="20%">20%</option>
              </select>
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="amount">Amount:</label>
            </div>
            <div>
              <input
                {...register("amount", {
                  required: "Amount is required",
                })}
                name="amount"
                type="number"
                min="0.00"
                step="0.01"
                placeholder="$0.00"
                className="w-72 text-2xl text-white bg-[#7a7a7a] focus:outline-none m-3 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          {errors.amount?.message && (
            <div className="text-2xl text-red-400 text-center">
              <span>{errors.amount?.message}</span>
            </div>
          )}
          <div className="flex items-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="tip">Tip:</label>
            </div>
            <div>
              <input
                {...register("tip", {
                  required: "Tip is required",
                })}
                name="tip"
                type="number"
                min="0.00"
                step="0.01"
                placeholder="$0.00"
                className="w-72 text-2xl text-white bg-[#7a7a7a] focus:outline-none m-3 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          {errors.tip?.message && (
            <div className="text-2xl text-red-400 text-center">
              <span>{errors.tip?.message}</span>
            </div>
          )}
          <div className="flex items-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="dateCreated">Date:</label>
            </div>
            <div>
              <input
                {...register("datecreated", {
                  required: "Date is required",
                })}
                name="datecreated"
                type="date"
                onChange={(e) => getDateValue(e.target.value)}
                className="w-72 text-2xl text-white bg-[#7a7a7a] focus:outline-none m-3 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          <div className="flex items-center justify-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="userName">User Name:</label>
            </div>
            <div>
              <input
                {...register("userName", {
                  required: "User Name is required",
                })}
                name="userName"
                required
                type="text"
                placeholder="userName"
                className="w-72 text-2xl text-white bg-[#7a7a7a] focus:outline-none m-3 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          {errors.userName?.message && (
            <div className="text-2xl text-red-400 text-center">
              <span>{errors.userName?.message}</span>
            </div>
          )}
          <div className="bg-gray">
            <SignatureCanvas
              ref={sigCanvasRef}
              canvasProps={{
                width: 400,
                height: 200,
                className: "sigCanvas",
              }}
            />
            <div className="flex justify-center gap-10 text-2xl">
              <button type="button" onClick={clear}>
                Clear
              </button>
              <button type="button" onClick={save}>
                Save
              </button>
            </div>
          </div>
        </div>
        <div className="flex justify-center gap-10">
          <TransactionSaveBtn
            canClick={isValid}
            isLoading={isLoading}
            actionText={"Save"}
            onClick={onSubmit}
          />
          <CancelBtn actionText={"Cancel"} onClick={onCancel} />
        </div>
      </form>
    </div>
  );
}

export default AddTransaction;
